import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M19.854 12.146a.5.5 0 0 0-.707 0l-9 9a.5.5 0 0 0 0 .707l2 2a.502.502 0 0 0 .707.001l9-9a.5.5 0 0 0 0-.707l-2-2.001zM12.5 22.793 11.207 21.5l8.293-8.293 1.293 1.293-8.293 8.293zm11.378-10.624-2.049-2.045a.5.5 0 0 0-.707.707l2.049 2.045a.498.498 0 0 0 .708 0 .501.501 0 0 0-.001-.707zM12.039 10.83c.181.037.363.056.546.056 1.085 0 2.185-.634 2.818-1.687.391-.792 1.01-1.268 1.745-1.341.729-.068 1.505.277 1.995.916.15.197.433.235.631.082a.451.451 0 0 0 .082-.631c-.677-.882-1.751-1.364-2.797-1.263-1.056.104-1.93.757-2.444 1.805-.53.876-1.52 1.355-2.395 1.182-.708-.146-1.161-.683-1.275-1.511a.45.45 0 1 0-.891.123c.166 1.199.908 2.047 1.985 2.269z",
      fill: "currentColor"
    })
  }));
};
export default SvgComponent;